import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowRoundClockwise12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconArrowRoundClockwise12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.325 5c-.54-1.855-2.377-2.886-4.257-2.382-1.906.51-2.984 2.38-2.473 4.286.51 1.907 2.38 2.986 4.284 2.475a3.6 3.6 0 0 0 1.397-.715 3 3 0 0 0 .396-.402l.014-.02a.5.5 0 0 1 .828.562l-.414-.28.414.28v.001l-.002.002-.003.005-.01.014-.032.042a4 4 0 0 1-.549.562 4.6 4.6 0 0 1-1.78.915C4.7 11 2.282 9.603 1.628 7.163s.742-4.858 3.18-5.511C6.95 1.078 9.074 2.074 10 3.98V2.5a.5.5 0 0 1 1 0V6H7.5a.5.5 0 1 1 0-1zm-.639 3.243V8.24z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowRoundClockwise12);
